import Parse from 'parse/dist/parse.min.js';
import { handleParseError } from '../../lib/Errors';

let localSubscription = undefined;

// Socialworker subscription
function createSubscription(store) {
	let personQuery = new Parse.Query('Person');
	personQuery.notEqualTo("deleted", true)
	personQuery.notEqualTo("type", "socialWorker")
	personQuery.addAscending("last_name")
		.limit(10000)
		.find() //das folgende evtl nochmal lesen//überarbeiten
		.then((results) => {
			store.dispatch('persons/set', results)
		})
		.catch((error) => {
			handleParseError(error);
			
		});
		personQuery.subscribe().then((subscription) => {
		localSubscription = subscription;

		subscription.on('create', (object) => {
			store.dispatch('persons/insert', object)
		});
		subscription.on('update', (object) => {
			store.dispatch('persons/replace', object)
		});
		subscription.on('enter', (object) => {
			store.dispatch('persons/insert', object)
		});
		subscription.on('leave', (object) => {
			store.dispatch('persons/delete', object)
		});
		subscription.on('delete', (object) => {
			store.dispatch('persons/delete', object)
		});
		subscription.on('close', () => {
		});
		subscription.on('error', error => {
            console.log('Person subscription error', error);
        })
	})
}

export default function createPersonSubscription() {
	return store => {
		if (store.state.currentUser) {
			createSubscription(store)
		}
		store.subscribe(mutation => {
			if (mutation.type === 'SET_CURRENT_USER') {
				if (localSubscription) {
					localSubscription.unsubscribe()
				}
				if (store.state.currentUser) {
					createSubscription(store)
				}
			}
		})
	}
}
